import React from 'react';

import ResumesHub from '../../../js/pages/ResumesHub';
import PageContainer from '../../../js/components/PageContainer';
import {loadHubProps, resolveSegment, unavailableHubProps} from '../../../js/pages/ResumesHub/loadHubProps';

// eslint-disable-next-line react/jsx-props-no-spreading
export default function Page(props) { return <ResumesHub {...props} />; }

Page.getLayout = (page) => (
  <PageContainer>
    {page}
  </PageContainer>
);

/** /resumes/<company> or /resumes/<role>. */
export async function getServerSideProps({req, params}) {
  // null is a path the library does not have; undefined, one it could not be
  // asked about just now.
  const segment = await resolveSegment(params.segment).catch(() => undefined);
  if (segment === null) return {notFound: true};
  if (!segment) return {props: await unavailableHubProps({req})};

  const props = await loadHubProps({
    req,
    filters: {
      companies: segment.company ? [segment.company] : [],
      roles: segment.role ? [segment.role] : [],
      levels: [],
    },
    segment,
  });
  return {props};
}
